/* eslint-disable max-len */
/* import { makeRequest, METHODS } from '@entando/apimanager';
import { getProdTypes } from 'test/mocks/products'; */
import axios from 'axios';
import { fuelheaders, fuelmultiheaders } from 'state/logged-user/actions';
import { SITE_SERVER } from './misc';

if (process.env.NODE_ENV !== 'development') {
  axios.defaults.withCredentials = true;
}

export const postAddProduct = (dataToSubmit, id) => axios({
  method: id !== null ? 'PUT' : 'POST',
  url: `${SITE_SERVER}/products${id !== null ? `/${id}` : ''}`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const requestProducts = (limit, page, type, text, vendorId, sortColumn, sortType) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/products?limit=${limit}&page=${page}${type !== null ? `&type=${type}` : ''}${text !== null ? `&text=${text}` : ''}${vendorId !== null ? `&vendor_id=${vendorId}` : ''}${sortColumn !== null ? `&sort_column=${sortColumn}` : ''}${sortType !== null ? `&sort_type=${sortType}` : ''}`,
  headers: fuelheaders(),
});

export const requestProductsReport = (limit, page, type, text, sku, description, sortColumn, sortType) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/products?limit=${limit}&page=${page}${type !== null ? `&type=${type}` : ''}${text !== null ? `&text=${text}` : ''}${sku !== null ? `&sku=${sku}` : ''}${description !== null ? `&description=${description}` : ''}${sortColumn !== null ? `&sort_column=${sortColumn}` : ''}${sortType !== null ? `&sort_type=${sortType}` : ''}`,
  headers: fuelheaders(),
});

export const requestProductDetails = id => axios({
  method: 'GET',
  url: `${SITE_SERVER}/products/${id}`,
  headers: fuelheaders(),
});

export const autoSearchProduct = (txt, limit, page) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/autocomplete/products?limit=${limit}&page=${page}&text=${txt}`,
  headers: fuelheaders(),
});

/* export const requestProductTypes = () => ( // eslint-disable-line
  makeRequest({
    uri: '/api/producttypes',
    method: METHODS.GET,
    mockResponse: getProdTypes(),
    useAuthentication: false,
  })
); */

export const requestProductTypes = () => axios({
  method: 'GET',
  url: `${SITE_SERVER.replace('/api', '')}/storage/data/productTypes.json`,
  headers: fuelheaders(),
});

export const postAddVendor = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/vendors`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const updateVendor = (id, dataToSubmit) => axios({
  method: 'PUT',
  url: `${SITE_SERVER}/vendors/${id}`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const postAddVendorOrders = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/vendorders`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

/* export const postAddVendorOrders = (dataToSubmit, id) => axios({
  method: id !== null ? 'PUT' : 'POST',
  url: `${SITE_SERVER}/vendorders${id !== null ? `/${id}` : ''}`,
  headers: fuelheaders(),
  data: dataToSubmit,
}); */

export const autoSearchVendor = (txt, limit, page) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/autocomplete/vendors?limit=${limit}&page=${page}&text=${txt}`,
  headers: fuelheaders(),
});

export const postAddManufacturer = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/manufacturers`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const autoSearchManufacturer = (txt, limit, page) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/autocomplete/manufacturers?limit=${limit}&page=${page}&text=${txt}`,
  headers: fuelheaders(),
});

export const importWMSProducts = () => axios({
  method: 'POST',
  url: `${SITE_SERVER}/wms_imports/products`,
  headers: fuelheaders(),
});

export const lastImportProducts = () => axios({
  method: 'GET',
  url: `${SITE_SERVER}/wms_imports/products`,
  headers: fuelheaders(),
});

export const requestProductSalesOrder = (id, limit, page, type, start, end) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/products/orders/${id}?limit=${limit}&page=${page}${type !== null ? `&type=${type}` : ''}${start !== null ? `&order_date_start=${start}` : ''}${end !== null ? `&order_date_end=${end}` : ''}`,
  headers: fuelheaders(),
});

export const stockAlertListing = (limit, page) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/products/stock_alert?limit=${limit}&page=${page}`,
  headers: fuelheaders(),
});

export const addProductStockAlert = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/products/stock_alert`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const updateProductStockAlert = (id, dataToSubmit) => axios({
  method: 'PUT',
  url: `${SITE_SERVER}/products/stock_alert/${id}`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const deleteProductStockAlert = id => axios({
  method: 'DELETE',
  url: `${SITE_SERVER}/products/stock_alert/${id}`,
  headers: fuelheaders(),
});

export const stockAlertRecipients = () => axios({
  method: 'GET',
  url: `${SITE_SERVER}/stockalerts/recipient`,
  headers: fuelheaders(),
});

export const addUpdateStockAlertRecipients = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/stockalerts/recipient`,
  headers: fuelheaders(),
  data: {
    emails: dataToSubmit,
  },
});

export const deleteStockAlertRecipients = () => axios({
  method: 'DEL',
  url: `${SITE_SERVER}/stockalerts/recipient/anythinghere`,
  headers: fuelheaders(),
});

export const requestSupplyReceipts = (limit, page, type, text, start, end, vendor, sortColumn, sortType) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/supplyreceipts?limit=${limit}&page=${page}${type !== null ? `&type=${type}` : ''}${text !== null ? `&text=${text}` : ''}${start !== null ? `&transaction_date_start=${start}` : ''}${end !== null ? `&transaction_date_end=${end}` : ''}${vendor !== null ? `&vendor=${vendor}` : ''}${sortColumn !== null ? `&sort_column=${sortColumn}` : ''}${sortType !== null ? `&sort_type=${sortType}` : ''}`,
  headers: fuelheaders(),
});

export const requestSupplyReceiptsReport = (limit, page, type, text, start, end, vendor, po, sku, sortColumn, sortType) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/supplyreceipts?limit=${limit}&page=${page}${type !== null ? `&type=${type}` : ''}${text !== null ? `&text=${text}` : ''}${start !== null ? `&transaction_date_start=${start}` : ''}${end !== null ? `&transaction_date_end=${end}` : ''}${vendor !== null ? `&vendor=${vendor}` : ''}${sku !== null ? `&sku=${sku}` : ''}${po !== null ? `&po_number=${po}` : ''}${sortColumn !== null ? `&sort_column=${sortColumn}` : ''}${sortType !== null ? `&sort_type=${sortType}` : ''}`,
  headers: fuelheaders(),
});

export const getSupplyReceiptInfo = id => axios({
  method: 'GET',
  url: `${SITE_SERVER}/supplyreceipts/${id}`,
  headers: fuelheaders(),
});

export const autoSearchFreight = (txt, limit, page) => axios({
  method: 'GET',
  url: `${SITE_SERVER}/autocomplete/freightforwarders?limit=${limit}&page=${page}&text=${txt}`,
  headers: fuelheaders(),
});

export const postFreight = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/freightforwarders`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const cancelVendorOrder = id => axios({
  method: 'PUT',
  url: `${SITE_SERVER}/vendorders/${id}/cancel`,
  headers: fuelheaders(),
});

export const settingsStockAlert = () => axios({
  method: 'GET',
  url: `${SITE_SERVER}/settings/stock_alert`,
  headers: fuelheaders(),
});

export const saveSettingsStockAlert = dataToSubmit => axios({
  method: 'PUT',
  url: `${SITE_SERVER}/settings/stock_alert`,
  headers: fuelheaders(),
  data: dataToSubmit,
});

export const postCSVProduct = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/products/loadcsvdata`,
  headers: fuelmultiheaders(),
  data: dataToSubmit,
});

export const saveCSVProduct = dataToSubmit => axios({
  method: 'POST',
  url: `${SITE_SERVER}/products/importcsvdata`,
  headers: fuelheaders(),
  data: dataToSubmit,
});
